"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag"));
const IssueStatus_1 = __importDefault(require("@opsbase/lib-issue/IssueStatus"));
const SPTType_1 = __importDefault(require("@opsbase/lib-spt/SPTType"));
const consts_1 = require("@opsbase/lib-time/consts");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
const AssetModel_1 = __importDefault(require("./AssetModel"));
const ConversationModel_1 = __importDefault(require("./ConversationModel"));
const OpDefinitionModel_1 = __importDefault(require("./OpDefinitionModel"));
const OpModel_1 = __importDefault(require("./OpModel"));
const PlaceModel_1 = __importDefault(require("./PlaceModel"));
const StaffModel_1 = __importDefault(require("./StaffModel"));
class IssueModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.title = '';
        this.flag = Flag_1.default.BLACK;
        this.type = '';
        this.status = IssueStatus_1.default.NEW;
        this.assignedToSPTType = SPTType_1.default.STAFF;
        this.causes = [];
        this.correctiveActions = [];
        this.preventativeActions = [];
        if (o === null || o === void 0 ? void 0 : o.conversation) {
            o.conversation = new ConversationModel_1.default(o.conversation);
        }
        else if (o === null || o === void 0 ? void 0 : o.comments) {
            o.conversation = new ConversationModel_1.default({ messages: o.comments, participants: o.commentors });
        }
        if (o === null || o === void 0 ? void 0 : o.place)
            o.place = new PlaceModel_1.default(o.place);
        if (o === null || o === void 0 ? void 0 : o.staff)
            o.staff = new StaffModel_1.default(o.staff);
        if (o === null || o === void 0 ? void 0 : o.op)
            o.op = new OpModel_1.default(o.op);
        if (o === null || o === void 0 ? void 0 : o.asset)
            o.asset = new AssetModel_1.default(o.asset);
        if (o === null || o === void 0 ? void 0 : o.opDefinition)
            o.opDefinition = new OpDefinitionModel_1.default(o.opDefinition);
        super.init(o);
    }
    get __typename() {
        return 'Issue';
    }
    set __typename(v) { }
    get closeDate() {
        if (this.status !== IssueStatus_1.default.CLOSED)
            return undefined;
        return this.closedDate || this.updatedDate;
    }
    get dueStatus() {
        var _a;
        const isClosed = this.status === IssueStatus_1.default.CLOSED;
        const closedDate = this.closedDate || this.updatedDate;
        const today = moment_timezone_1.default.tz(((_a = this.place) === null || _a === void 0 ? void 0 : _a.timezone) || consts_1.DefaultTimezone).startOf('day');
        const hasDeadline = !!this.deadlineDate;
        const deadlineDateStart = hasDeadline && (0, moment_timezone_1.default)(this.deadlineDate.startOf('day'));
        const closedDateStart = isClosed && (0, moment_timezone_1.default)(closedDate.startOf('day'));
        const isLate = hasDeadline && !isClosed && deadlineDateStart.isBefore(today);
        const wasLate = hasDeadline && deadlineDateStart.isBefore(closedDateStart);
        const deadlineFromToday = !hasDeadline
            ? ''
            : deadlineDateStart.diff(today, 'days') === 0
                ? ''
                : isLate
                    ? `${deadlineDateStart.from(today, true)} late`
                    : `due in ${deadlineDateStart.from(today, true)}`;
        const deadlineFromClosed = !hasDeadline
            ? ''
            : isClosed && deadlineDateStart.diff(closedDateStart, 'days') === 0
                ? ''
                : wasLate
                    ? `${deadlineDateStart.from(closedDateStart, true)} late`
                    : '';
        return isClosed ? deadlineFromClosed : deadlineFromToday;
    }
    get resolutionTime() {
        const isClosed = this.status === IssueStatus_1.default.CLOSED;
        if (!isClosed)
            return '';
        const closedDate = this.closedDate || this.updatedDate;
        const openedDateStart = (0, moment_timezone_1.default)(this.occurrenceDate.startOf('day'));
        const closedDateStart = (0, moment_timezone_1.default)(closedDate.startOf('day'));
        if (closedDateStart.diff(openedDateStart, 'days') === 0) {
            if (closedDateStart.diff(openedDateStart, 'hours') === 0) {
                return 'Resolved immediately';
            }
            return `${closedDateStart.diff(openedDateStart, 'hours')} hours to resolve`;
        }
        return `${closedDateStart.from(openedDateStart, true)} to resolve`;
    }
}
exports.IssueModel = IssueModel;
IssueModel.ALL_FIELDS = `id,
		title,
		flag, type, status,
		occurrenceDate,
		deadlineDate,
		startedDate,
		updatedDate,
		closedDate,
		activity,
		place { id, title, timezone },
	    createdBy { id, title, hasProfileImage, profileImageUrl, enabled   },
	    startedBy { id, title, hasProfileImage, profileImageUrl   },
	    updatedBy { id, title, hasProfileImage, profileImageUrl   },
	    closedBy { id, title, hasProfileImage, profileImageUrl  },
	    assignedToSPTType,
	    assignedToStaff { id, title, hasProfileImage, profileImageUrl, enabled },
	    assignedToPosition { id, title },
	    assignedToTeam { id, title },
	    asset { id, title },
	    op { id, title, startFrom, completeBy, actualStart, actualComplete, isScoreEnabled, isAdhoc }
		conversation { id, title, messages, participants { id, title, hasProfileImage, profileImageUrl } relatedIssue { id } }
		causes,
		correctiveActions,
		preventativeActions,
		associatedIntegrationId,`;
exports.default = IssueModel;
ModelRegistry_1.default[DataType_1.default.ISSUE] = IssueModel;
ModelRegistry_1.default[DataType_1.default.ISSUE_TODO] = IssueModel;
